export default __webpack_public_path__ + "static/media/logo.afbf0cbb.svg";